import React, { use, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../CustomComponent/custom_view_button";

const tableHead = ["Sr.", "Name", "Test Attempted", "Due Date", "Actions"];

const TraineeTable = ({ EX = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const [id, setId] = useState(null);
  const store = useSelector((store) => store.login.user);

  const goToView = (id) => {
    navigate(`/employee-test-overview/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {EX?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>

                <td>{item?.user_model?.userName || "N/A"}</td>
                <td>{`${item?.testCompleted} / 5` || "N/A" / 5}</td>

                <td>{item?.dueDate || "N/A"}</td>

                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.user_model.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TraineeTable;
